module.exports = __webpack_public_path__ + "media/images/faq-9e038728.jpg";